import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getProductionList = (page, pagesize, search, ordering,shift,press,start_date,end_date) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/production/`, {
        headers: authHeader(),
        params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering,
            shift:shift,
            press:press,
            start_date:start_date,
            end_date:end_date
        },
    });
};

const createProduction = payload => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/production/`,
        payload,
        {
            headers: authHeader(),
        },
    );
};


const getProductionById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/production/${id}`, {
        headers: authHeader(),
    });
}

const editProduction = (id, payload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/production/${id}/`,
        payload,
        { headers: authHeader() }
    );
};

const productionService = {
    getProductionList,
    createProduction,
    getProductionById,
    editProduction,
};

export default productionService;
